<template>
  <div class="">
    <loading-overlay :overlay="loading"></loading-overlay>
    <div v-if="buttonScan" class="center-content">
      <h2 style="font-weight: bold">Escánear pase de acceso</h2>
      <v-icon color="gray" size="150" :style="{ width: '240px', height: '240px' }"
        >qr_code_scanner</v-icon
      >
      <span style="text-align: center; font-size: 12px; margin-bottom: 30px; color: gray"
        >Haga clic en el botón para iniciar el escaneo del pase de acceso QR.
      </span>
      <v-btn @click="mostrarCamaraFunction" block class="black" dark>Escanear</v-btn>
    </div>

    <v-dialog v-model="dialog_vistaprevia" max-width="600">
      <v-card>
        <v-card-title class="headline">Vista Previa</v-card-title>
        <v-card-text>
          <!-- Aquí se muestra la imagen desde el URL -->
          <v-img max-height="150" max-width="250" :src="imagen_url"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog_vistaprevia = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="mostrarRegistros">
      <template>
        <v-tabs v-model="tab" fixed-tabs dense>
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tab-1"> Personal </v-tab>
          <v-tab href="#tab-2"> Vehiculos </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-list subheader dense two-line>
              <v-list-item-group color="gray">
                <v-text-field
                  style="margin-top: 10px"
                  outlined
                  dense
                  @input="filterList()"
                  v-model="filterQuery"
                  label="Buscar..."
                ></v-text-field>

                <v-virtual-scroll
                  :items="pasajeros"
                  :item-height="56"
                  :height="400"
                  v-slot="{ item, index }"
                >
                  <v-list-item
                    active-class="gray--text"
                    :key="index"
                    @click="viewInfoItem(item)"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="font-size: 12px">
                        {{ item.nombre_completo }}
                      </v-list-item-title>

                      <v-list-item-subtitle style="font-size: 12px">
                        {{ item.compania }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-chip
                        v-if="item.access_logs.length == 0"
                        small
                        color="orange"
                        dark
                        class="ma-2"
                        >{{ item.access_logs.length }} accesos</v-chip
                      >
                      <v-chip
                        v-if="item.access_logs.length > 0"
                        small
                        color="green"
                        dark
                        class="ma-2"
                        >{{ item.access_logs.length }} acceso</v-chip
                      >
                    </v-list-item-action>
                  </v-list-item>
                </v-virtual-scroll>
              </v-list-item-group>
              <v-btn block color="black" @click="escanAgain" dark class="">
                Escanear otro pase
              </v-btn>
            </v-list>
          </v-tab-item>
          <v-tab-item value="tab-2">
            <v-card flat>
              <v-list subheader dense two-line>
                <v-list-item-group color="gray">
                  <v-text-field
                    style="margin-top: 10px"
                    outlined
                    dense
                    label="Buscar placa..."
                    @input="filterListVehiculs()"
                    v-model="filterQueryVehiculs"
                  ></v-text-field>

                  <v-virtual-scroll
                    :items="vehiculos"
                    :item-height="56"
                    :height="400"
                    v-slot="{ item, index }"
                  >
                    <v-list-item
                      active-class="gray--text"
                      :key="index"
                      @click="viewInfoItem(item)"
                    >
                      <v-list-item-content>
                        <v-list-item-title style="font-size: 12px">
                          {{ item.marca }}
                        </v-list-item-title>

                        <v-list-item-subtitle style="font-size: 12px">
                          {{ item.placa }}
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-chip
                          v-if="item.access_logs.length == 0"
                          small
                          color="orange"
                          dark
                          class="ma-2"
                          >{{ item.access_logs.length }} accesos</v-chip
                        >
                        <v-chip
                          v-if="item.access_logs.length > 0"
                          small
                          color="green"
                          dark
                          class="ma-2"
                          >{{ item.access_logs.length }} acceso</v-chip
                        >
                      </v-list-item-action>
                    </v-list-item>
                  </v-virtual-scroll>
                </v-list-item-group>
                <v-btn block color="black" @click="escanAgain" dark class="">
                  Escanear otro pase
                </v-btn>
              </v-list>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-bottom-sheet v-model="sheet">
          <v-sheet
            class="text-center"
            height="400px"
            style="max-height: 480px; overflow-y: auto"
          >
            <div class="py-3 px-3">
              <h3>Gestión de Acceso</h3>
              <v-btn
                icon
                @click="triggerFileInput"
                :style="{ width: '80px', height: '80px' }"
              >
                <v-icon
                  color="gray"
                  size="40"
                  :style="{ width: '100px', height: '140px' }"
                  >photo_camera</v-icon
                >
              </v-btn>
              <input
                ref="fileInput"
                type="file"
                accept="image/*"
                capture="camera"
                style="display: none"
                @change="handleFileChange"
              />

              <v-img
                v-if="imagePreview"
                :src="imagePreview"
                max-width="50%"
                max-height="120"
                class="mt-4"
              />
              <div class="mt-6" style="font-size: 13px">
                <div v-if="this.tab == 'tab-1'">
                  <span style="font-size: 12px">
                    Adjunte la evidencia necesaria para otorgar acceso a
                    <strong>{{ itemSelected.nombre_completo }}</strong> de la compañia
                    <strong>{{ itemSelected.compania }}</strong> y luego presione el botón
                    para confirmar.
                  </span>
                </div>
                <div v-if="this.tab == 'tab-2'">
                  <span>
                    Para otorgar acceso al vehículo de marca
                    <strong>{{ itemSelected.marca }}</strong> con placa
                    <strong>{{ itemSelected.placa }}</strong> y color
                    <strong>{{ itemSelected.color }}</strong
                    >, adjunte la evidencia necesaria y asegúrese de que el seguro de
                    <strong>{{ itemSelected.compania_aseguradora }}</strong> con vigencia
                    <strong>{{ itemSelected.vigenciaSeguro }}</strong> esté vigente.
                    Luego, presione el botón para dar acceso.
                  </span>
                </div>
              </div>

              <!-- Botón de autorizar acceso -->
              <v-btn
                v-if="tab == 'tab-1'"
                :loading="loading"
                :disabled="!imagePreview"
                @click="autorizarAcceso"
                block
                class="mt-3"
                >Aprobar acceso a personal</v-btn
              >
              <v-btn
                v-if="tab == 'tab-2'"
                :loading="loading"
                :disabled="!imagePreview"
                @click="autorizarAccesoVehiculo"
                block
                class="mt-3"
                >Aprobar acceso a vehiculo</v-btn
              >

              <div class="py-3 px-3">
                <v-list v-model="listSelected" dense>
                  <v-subheader>Accesos registrados</v-subheader>
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="(item, index) in itemSelected.access_logs"
                      :key="index"
                      @click="mostrarImagen(item.evidencia)"
                    >
                      <v-list-item-icon class="item-center">
                        <v-chip x-small> {{ index + 1 }}</v-chip>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ item.timestamp_acceso | moment("dddd Do MM YYYY, H:mm") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                  </v-list-item-group>
                </v-list>
              </div>
            </div>
          </v-sheet>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="sheetApprove">
          <v-sheet
            class="text-center"
            height="400px"
            style="max-height: 480px; overflow-y: auto"
          >
            <div class="py-3 px-3 center-content">
              <h3>Información de Acceso</h3>
              <v-list dense>
                <v-subheader>REPORTS</v-subheader>
                <v-list-item-group color="primary">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon>check</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title> Acceso</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>

              <div class="mt-6" style="font-size: 13px">
                <div v-if="this.tab == 'tab-1'">
                  <span style="font-size: 12px">
                    El acceso de
                    <strong>{{ itemSelected.nombre_completo }}</strong> de la compañía
                    <strong>{{ itemSelected.compania }}</strong> fue autorizado el día
                    <strong>{{ formatDate(itemSelected.timestamp_acceso) }}</strong> a las
                    <strong>{{ formatTime(itemSelected.timestamp_acceso) }}</strong
                    >.
                  </span>
                </div>

                <div v-if="this.tab == 'tab-2'">
                  <span style="font-size: 12px">
                    El acceso del vehículo de marca
                    <strong>{{ itemSelected.marca }}</strong> con placa
                    <strong>{{ itemSelected.placa }}</strong> y color
                    <strong>{{ itemSelected.color }}</strong> fue registrado el día
                    <strong>{{ formatDate(itemSelected.timestamp_acceso) }}</strong> a las
                    <strong>{{ formatTime(itemSelected.timestamp_acceso) }}</strong
                    >. La aseguradora es
                    <strong>{{ itemSelected.compania_aseguradora }}</strong> con vigencia
                    hasta <strong>{{ itemSelected.vigenciaSeguro }}</strong
                    >.
                  </span>
                </div>
              </div>
            </div>
          </v-sheet>
        </v-bottom-sheet>
      </template>
    </div>

    <qrcode-stream
      v-if="mostrarCamara"
      :camera="camera"
      @decode="onDecode"
      @init="onInit"
    >
      <div v-show="showScanConfirmation" class="scan-confirmation">
        <v-icon x-large color="blue">mdi-barcode-scan</v-icon>
      </div>
    </qrcode-stream>
  </div>
</template>

<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from "vue-qrcode-reader";
import LoadingOverlay from "../components/Loading.vue";
import {
  getPassengerVehiculs,
  updatePassengerAccess,
  updateVehicleAccess,
} from "../../api/endpoints";
import { uploadImage } from "../../helpers/handleUploadsDocument";
import axios from "axios";
export default {
  name: "home",
  components: {
    QrcodeStream,
    LoadingOverlay,
  },
  data() {
    return {
      buttonScan: true,
      sheet: false,
      sheetApprove: false,
      imagePreview: null,
      filterQuery: null,
      filterQueryVehiculs: null,
      mostrarRegistros: false,
      info: [],
      fileImage: "",
      itemSelected: [],
      listSelected: "",
      tabs: [],
      camera: "auto",
      pasajeros: [],
      vehiculos: [],
      imagen_url: "",
      dialog_vistaprevia: "",
      tab: null,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      showScanConfirmation: false,
      mostrarCamara: false,
      loading: false,
    };
  },
  methods: {
    // Inicializa la cámara del scanner QR y maneja estados de carga
    async onInit(promise) {
      try {
        this.loading = true;
        await promise;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
        // Muestra confirmación visual cuando la cámara está desactivada
        this.showScanConfirmation = this.camera === "off";
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    // Maneja la selección de archivos de evidencia (imagen) del input file
    handleFileChange(event) {
      const file = event.target.files[0];
      this.fileImage = file; // Guarda archivo para posterior upload
      if (file) {
        // Crear FileReader para mostrar preview de la imagen seleccionada
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result; // Base64 para preview
        };
        reader.readAsDataURL(file);
      }
    },

    // Procesa el código QR escaneado y obtiene los datos del pase de acceso
    async onDecode(content) {
      this.result = content; // ID del pase escaneado
      this.mostrarRegistros = true; // Muestra las pestañas de personal/vehículos
      this.pause(); // Pausa la cámara
      console.log(content);
      this.getDataQr(content); // Obtiene datos del backend usando el ID
      this.buttonScan = false; // Oculta botón de escanear
      this.mostrarCamara = false; // Oculta cámara
    },

    pause() {
      this.camera = "off";
    },
    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },

    mostrarCamaraFunction() {
      this.mostrarCamara = true;
      this.camera = "auto";
      this.buttonScan = false;
    },

    // Obtiene los datos del pase (pasajeros y vehículos) usando el ID escaneado
    async getDataQr(_id) {
      this.loading = true;
      await getPassengerVehiculs(_id)
        .then((e) => {
          // Carga datos obtenidos del backend
          this.info = e;
          this.pasajeros = e.pasajeros; // Lista de personal autorizado
          this.vehiculos = e.vehiculos; // Lista de vehículos autorizados
        })
        .catch((err) => {
          // Manejo de error: folio inexistente o no autorizado
          this.$notify({
            title: "¡Alerta!",
            text: "El folio no se encuentra registrado o no esta autorizado",
            type: "warning",
          });
          this.escanAgain(); // Reinicia el proceso de escaneo
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Muestra información detallada del elemento seleccionado (persona o vehículo)
    viewInfoItem(item) {
      // Lógica condicional: si ya ingresó muestra sheet de aprobación, si no muestra sheet de autorización
      if (item.estado == "Ingresado" ? (this.sheetApprove = true) : (this.sheet = true))
        this.imagePreview = null; // Resetea preview de imagen
      this.itemSelected = item; // Guarda elemento seleccionado para mostrar detalles
    },

    escanAgain() {
      this.pasajeros = [];
      this.vehiculos = [];
      this.mostrarRegistros = false;
      this.buttonScan = true;
    },

    // Autoriza el acceso de personal capturando evidencia e información del dispositivo
    async autorizarAcceso() {
      // Obtiene IP pública del usuario para auditoria
      const response_ip = await axios.get("https://api.ipify.org?format=json");

      // Construye payload con datos del acceso y metadatos del dispositivo
      const data = {
        _id: this.info._id, // ID del pase
        evidencia: "", // URL de evidencia (se asigna después del upload)
        _idPassenger: this.itemSelected._id, // ID del pasajero
        // Metadatos del dispositivo para auditoria de seguridad
        os: navigator.platform || "Desconocido",
        browser:
          navigator.userAgent.match(
            /(Chrome|Firefox|Safari|Opera|Edge|MSIE|Trident)/
          )?.[0] || "Desconocido",
        device: /Mobile|Android|iP(ad|hone|od)/i.test(navigator.userAgent)
          ? "Mobile"
          : "Desktop",
        ip: response_ip.data.ip, // IP para trazabilidad
      };

      this.loading = true;

      try {
        // Proceso de autorización: 1) Subir evidencia, 2) Registrar acceso
        const imagen_url = await uploadImage(this.fileImage);
        data.evidencia = imagen_url; // Asigna URL de imagen subida

        // Validación de autenticación
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token no disponible");
        }

        // Registro del acceso en backend con autenticación
        const response = await axios.put("vehiculoPersonal/autorizar_acceso", data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        console.log(response.data);
        this.sheet = false; // Cierra modal
        this.getDataQr(this.info._id); // Actualiza datos para reflejar nuevo estado
      } catch (err) {
        console.log(err);
        // Manejo de errores con notificación al usuario
        this.$notify({
          title: "¡Alerta!",
          text: err.response.data.message,
          type: "warning",
        });
      } finally {
        this.loading = false;
      }
    },

    formatDate(date) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(date).toLocaleDateString(undefined, options);
    },

    formatTime(date) {
      const options = { hour: "2-digit", minute: "2-digit" };
      return new Date(date).toLocaleTimeString(undefined, options);
    },

    // Autoriza el acceso de vehículos con evidencia fotográfica y metadatos de auditoria
    async autorizarAccesoVehiculo() {
      let me = this;
      // Obtiene IP para registro de auditoria
      const response_ip = await axios.get("https://api.ipify.org?format=json");

      this.loading = true;
      // Payload con información del vehículo y metadatos del dispositivo
      const data = {
        _id: this.info._id, // ID del pase
        evidencia: "", // URL de evidencia (imagen)
        _idVehiculo: this.itemSelected._id, // ID del vehículo
        // Información del dispositivo para trazabilidad de seguridad
        os: navigator.platform || "Desconocido",
        browser:
          navigator.userAgent.match(
            /(Chrome|Firefox|Safari|Opera|Edge|MSIE|Trident)/
          )?.[0] || "Desconocido",
        device: /Mobile|Android|iP(ad|hone|od)/i.test(navigator.userAgent)
          ? "Mobile"
          : "Desktop",
        ip: response_ip.data.ip, // IP del dispositivo
      };

      // Sube imagen de evidencia y asigna URL al payload
      const imagen_url = await uploadImage(this.fileImage);
      data.evidencia = imagen_url;

      // Registra acceso del vehículo en backend
      await updateVehicleAccess(data)
        .then((e) => {
          me.sheet = false; // Cierra modal de autorización
          me.getDataQr(this.info._id); // Actualiza estado de los datos
        })
        .catch((err) => {
          // Notificación de error al usuario
          me.$notify({
            title: "!Alerta!",
            text: err.response.data.message,
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Filtro de búsqueda para lista de pasajeros por nombre completo
    filterList() {
      if (this.info.pasajeros) {
        // Filtra pasajeros que coincidan con el texto de búsqueda (case insensitive)
        this.pasajeros = this.info.pasajeros.filter((item) =>
          item.nombre_completo.toLowerCase().includes(this.filterQuery.toLowerCase())
        );
      }
    },
    // Filtro de búsqueda para lista de vehículos por placa
    filterListVehiculs() {
      if (this.info.vehiculos) {
        // Filtra vehículos que coincidan con la placa buscada (case insensitive)
        this.vehiculos = this.info.vehiculos.filter((item) =>
          item.placa.toLowerCase().includes(this.filterQueryVehiculs.toLowerCase())
        );
      }
    },

    mostrarImagen(imagen) {
      this.dialog_vistaprevia = true;

      this.imagen_url = imagen;
    },
  },
};
</script>

<style scoped>
.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.center-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
